import { render } from "./PackageEditor.vue?vue&type=template&id=534760a2&scoped=true"
import script from "./PackageEditor.vue?vue&type=script&lang=js"
export * from "./PackageEditor.vue?vue&type=script&lang=js"

import "./PackageEditor.vue?vue&type=style&index=0&id=534760a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-534760a2"]])

export default __exports__